<meta name="viewport" content="width=device-width, user-scalable=no" />
<meta charset="UTF-8" />
@if (multilingualService.langMapObservable | async; as langMap) {
  <div class="main">
    <div class="web-header-section">
      <app-logo></app-logo>
    </div>
    <div class="account-custom-wrapper">
      <div id="header_section" class="header-section">
        <div class="device-logo">
          <app-logo></app-logo>
        </div>
      </div>
      <section id="content" class="login-content">
        <div class="signup-header">
          <h2 id="main_header_text" class="login-main-header mb-0">
            {{ multilingualService.langMap?.LABEL_REGISTRATION_CREATE_ACCOUNT }}
          </h2>
        </div>
        <mat-horizontal-stepper [linear]="true" #stepper>
          <!-- Step 1 -->
          <mat-step>
            <div>
              <div id="signup_progress_bar"></div>
              <div id="initial_widget">
                <div id="initial_widget_introduction" class="stepper-title">
                  {{ multilingualService.langMap?.LABEL_REGISTRATION_STEP1_TITLE }}
                </div>
                <div class="item d-flex">
                  <div class="item-number d-flex">
                    <img
                      imageName="square-bracket-1.svg"
                      alt="1."
                      data-tenant-branding-logo="true"
                    />
                  </div>
                  <div id="initial_widget_point_1">
                    {{ multilingualService.langMap?.LABEL_REGISTRATION_POINT_1 }}
                  </div>
                </div>
                <div class="item d-flex">
                  <div class="item-number d-flex">
                    <img
                      imageName="square-bracket-2.svg"
                      alt="2."
                      data-tenant-branding-logo="true"
                    />
                  </div>
                  <div id="initial_widget_point_2">
                    {{ multilingualService.langMap?.LABEL_REGISTRATION_POINT_2 }}
                  </div>
                </div>
                <div class="item d-flex">
                  <div class="item-number d-flex">
                    <img
                      imageName="square-bracket-3.svg"
                      alt="3."
                      data-tenant-branding-logo="true"
                    />
                  </div>
                  <div id="initial_widget_point_3">
                    {{ multilingualService.langMap?.LABEL_REGISTRATION_POINT_3 }}
                  </div>
                </div>
                <button
                  id="start_registration_btn"
                  aria-label="Start Registration Process"
                  class="primary-button mt-2 mb-2"
                  (click)="stepper.selectedIndex = 1"
                >
                  {{ multilingualService.langMap?.LABEL_REGISTRATION_CREATE_ACCOUNT_BTN }}
                </button>
              </div>
            </div>
          </mat-step>
          <!-- Step 2 -->
          <mat-step>
            <div class="progress-container">
              <div
                class="progress-label"
                [style.left.%]="progressBarValues[0]"
                style="margin-left: 10px"
              >
                {{ progressBarValues[0] }}%
              </div>
              <mat-progress-bar
                mode="determinate"
                [value]="progressBarValues[0]"
              ></mat-progress-bar>
            </div>
            <div class="stepper-title">
              {{ multilingualService.langMap?.LABEL_REGISTRATION_STEP2_TITLE }}
              <p>
                {{ multilingualService.langMap?.LABEL_REGISTRATION_STEP2_NOTE }}
              </p>
            </div>
            <form [formGroup]="memberDetailsForm">
              <div class="form-group mb-2">
                <label for="firstName">
                  {{ multilingualService.langMap?.LABEL_REGISTRATION_FIRST_NAME }}
                  <span class="input-required-on-dark-bg text-w-600">*</span>
                </label>
                <input
                  formControlName="firstName"
                  type="text"
                  class="form-control"
                  maxlength="50"
                />
                @if (
                  memberDetailsForm?.controls?.firstName?.errors?.required &&
                  memberDetailsForm?.controls?.firstName?.touched
                ) {
                  <span role="alert" class="text-danger">
                    {{
                      multilingualService.langMap?.LABEL_REGISTRATION_FIRST_NAME_VALIDATION_REQUIRED
                    }}
                  </span>
                }
                @if (
                  memberDetailsForm?.controls?.firstName?.errors?.pattern &&
                  memberDetailsForm?.controls?.firstName?.touched
                ) {
                  <span role="alert" class="text-danger">
                    {{
                      multilingualService.langMap?.LABEL_REGISTRATION_FIRST_NAME_VALIDATION_INVALID
                    }}
                  </span>
                }
              </div>
              <div class="form-group mb-2">
                <label for="lastName">
                  {{ multilingualService.langMap?.LABEL_REGISTRATION_LAST_NAME }}
                  <span class="input-required-on-dark-bg text-w-600">*</span>
                </label>
                <input formControlName="lastName" type="text" maxlength="50" class="form-control" />
                @if (
                  memberDetailsForm?.controls?.lastName?.errors?.required &&
                  memberDetailsForm?.controls?.lastName?.touched
                ) {
                  <span role="alert" class="text-danger">
                    {{
                      multilingualService.langMap?.LABEL_REGISTRATION_LAST_NAME_VALIDATION_REQUIRED
                    }}
                  </span>
                }
                @if (
                  memberDetailsForm?.controls?.lastName?.errors?.pattern &&
                  memberDetailsForm?.controls?.lastName?.touched
                ) {
                  <span role="alert" class="text-danger">
                    {{
                      multilingualService.langMap?.LABEL_REGISTRATION_LAST_NAME_VALIDATION_INVALID
                    }}
                  </span>
                }
              </div>
              <div class="form-group mb-2">
                <label for="DOB">
                  {{ multilingualService.langMap?.LABEL_REGISTRATION_DOB }}
                  <span class="input-required-on-dark-bg text-w-600">*</span>
                </label>
                <mat-form-field appearance="fill" class="dob-datepicker full-width">
                  <input
                    matInput
                    formControlName="DOB"
                    maxlength="10"
                    [max]="maxDate"
                    appNumberOnly
                    [matDatepicker]="picker"
                  />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                @if (
                  (memberDetailsForm.get('DOB')?.errors?.pattern ||
                    memberDetailsForm.get('DOB')?.errors?.invalidDate) &&
                  memberDetailsForm.get('DOB')?.touched &&
                  !memberDetailsForm.get('DOB')?.errors?.required
                ) {
                  <span class="text-danger">
                    {{ multilingualService.langMap?.LABEL_REGISTRATION_DOB_VALIDATION_MESSAGE }}
                  </span>
                }
                @if (
                  memberDetailsForm.get('DOB')?.errors?.required &&
                  memberDetailsForm.get('DOB')?.touched
                ) {
                  <span class="text-danger">
                    {{
                      multilingualService.langMap
                        ?.LABEL_REGISTRATION_DOB_REQUIRED_VALIDATION_MESSAGE
                    }}
                  </span>
                }
                @if (
                  memberDetailsForm.get('DOB')?.errors?.minor &&
                  memberDetailsForm.get('DOB')?.touched
                ) {
                  <span class="text-danger">
                    {{
                      multilingualService.langMap?.LABEL_REGISTRATION_DOB_MINOR_VALIDATION_MESSAGE
                    }}
                  </span>
                }
              </div>
            </form>
            <div class="action-buttons">
              <button
                id="back_btn1"
                aria-label="Go back to prev step"
                class="back-button"
                (click)="handleBackNavigation()"
              >
                {{ multilingualService.langMap?.LABEL_REGISTRATION_BACK_BTN }}
              </button>
              <button
                id="next_btn1"
                aria-label="Go to next step"
                class="primary-button"
                (click)="goToNextStep()"
                [disabled]="memberDetailsForm.invalid"
              >
                {{ multilingualService.langMap?.LABEL_REGISTRATION_NEXT_BTN }}
              </button>
            </div>
          </mat-step>
          <!-- Step 3 -->
          <mat-step>
            <div class="progress-container">
              <div class="progress-label" [style.left.%]="progressBarValues[1]">
                {{ progressBarValues[1] }}%
              </div>
              <mat-progress-bar
                mode="determinate"
                [value]="progressBarValues[1]"
              ></mat-progress-bar>
            </div>
            <div class="stepper-title">
              {{ multilingualService.langMap?.LABEL_REGISTRATION_STEP3_TITLE }}
              <p>
                {{ multilingualService.langMap?.LABEL_REGISTRATION_STEP3_NOTE }}
              </p>
            </div>
            <a class="view-sample-card" (click)="viewSampleIdCard()">
              <img imageName="card-icon.svg" [common]="true" />
              {{ multilingualService.langMap?.LABEL_REGISTRATION_VIEW_SAMPLE_CARD }}
            </a>
            @if (eligibilityCheckAPIErr) {
              <div role="alert" class="text-danger mb-2">
                {{ eligibilityCheckAPIErr }}
              </div>
            }
            <div class="card-details-form">
              <form [formGroup]="cardDetailsForm">
                <div class="form-group mb-2">
                  <label for="rxGroup">
                    {{ multilingualService.langMap?.LABEL_REGISTRATION_RX_GROUP }}
                    <span class="input-required-on-dark-bg text-w-600">*</span>
                    (&#9651;)
                  </label>
                  <input formControlName="rxGroup" type="text" maxlength="7" class="form-control" />
                  @if (
                    cardDetailsForm?.controls?.rxGroup?.errors?.required &&
                    cardDetailsForm?.controls?.rxGroup?.touched
                  ) {
                    <span role="alert" class="text-danger">
                      {{
                        multilingualService.langMap?.LABEL_REGISTRATION_RX_GROUP_VALIDATION_REQUIRED
                      }}
                    </span>
                  }
                  @if (
                    cardDetailsForm?.controls?.rxGroup?.errors?.pattern &&
                    cardDetailsForm?.controls?.rxGroup?.touched
                  ) {
                    <span role="alert" class="text-danger">
                      {{
                        multilingualService.langMap?.LABEL_REGISTRATION_RX_GROUP_VALIDATION_INVALID
                      }}
                    </span>
                  }
                </div>
                <div class="form-group mb-2">
                  <label for="memberId">
                    {{ multilingualService.langMap?.LABEL_REGISTRATION_MEMBER_ID }}
                    <span class="input-required-on-dark-bg text-w-600">*</span>
                    (&#9634;)
                  </label>
                  <input
                    formControlName="memberId"
                    type="text"
                    maxlength="20"
                    class="form-control"
                  />
                  @if (
                    cardDetailsForm?.controls?.memberId?.errors?.required &&
                    cardDetailsForm?.controls?.memberId?.touched
                  ) {
                    <span role="alert" class="text-danger">
                      {{
                        multilingualService.langMap
                          ?.LABEL_REGISTRATION_MEMBER_ID_VALIDATION_REQUIRED
                      }}
                    </span>
                  }
                  @if (
                    cardDetailsForm?.controls?.memberId?.errors?.pattern &&
                    cardDetailsForm?.controls?.memberId?.touched
                  ) {
                    <span role="alert" class="text-danger">
                      {{
                        multilingualService.langMap?.LABEL_REGISTRATION_MEMBER_ID_VALIDATION_INVALID
                      }}
                    </span>
                  }
                </div>
              </form>
              <img pointer imageName="sample-id-card.svg" width="360" alt="Back" />
            </div>
            <div class="action-buttons">
              <button
                id="back_btn2"
                aria-label="Go back to prev step"
                class="back-button"
                (click)="handleBackNavigation()"
              >
                {{ multilingualService.langMap?.LABEL_REGISTRATION_BACK_BTN }}
              </button>
              <button
                id="next_btn2"
                aria-label="Go to next step"
                class="primary-button"
                [disabled]="cardDetailsForm.invalid"
                (click)="checkEligibility()"
              >
                {{ multilingualService.langMap?.LABEL_REGISTRATION_NEXT_BTN }}
              </button>
            </div>
          </mat-step>
          <!-- Step 4 -->
          <mat-step>
            <div class="progress-container">
              <div class="progress-label" [style.left.%]="progressBarValues[2]">
                {{ progressBarValues[2] }}%
              </div>
              <mat-progress-bar
                mode="determinate"
                [value]="progressBarValues[2]"
              ></mat-progress-bar>
            </div>
            <div class="stepper-title">
              {{ multilingualService.langMap?.LABEL_REGISTRATION_STEP4_TITLE }}
              {{ memberDetailsForm?.value?.firstName }},
              <p>
                {{ multilingualService.langMap?.LABEL_REGISTRATION_STEP4_NOTE }}
              </p>
            </div>
            @if (registrationAPIErr) {
              <div role="alert" class="text-danger">
                {{ registrationAPIErr }}
              </div>
            }
            @if (memberRecordExists) {
              <p role="alert" class="text-success">
                {{ multilingualService.langMap?.LABEL_REGISTRATION_RECORD_EXISTS_1 }}
                <b>"{{ contactDetailsForm.controls.userName.value }}"</b>
                . {{ multilingualService.langMap?.LABEL_REGISTRATION_RECORD_EXISTS_2 }}.
              </p>
            }
            <form [formGroup]="contactDetailsForm">
              <div class="form-group mb-2">
                <label for="userName">
                  {{ multilingualService.langMap?.LABEL_REGISTRATION_USER_NAME }}
                  <span class="input-required-on-dark-bg text-w-600">*</span>
                </label>
                <input formControlName="userName" type="text" maxlength="36" class="form-control" />
                @if (
                  contactDetailsForm?.controls?.userName?.errors?.required &&
                  contactDetailsForm?.controls?.userName?.touched
                ) {
                  <span role="alert" class="text-danger">
                    {{
                      multilingualService.langMap?.LABEL_REGISTRATION_USER_NAME_VALIDATION_REQUIRED
                    }}
                  </span>
                }
                @if (
                  contactDetailsForm?.controls?.userName?.errors?.pattern &&
                  contactDetailsForm?.controls?.userName?.touched
                ) {
                  <span role="alert" class="text-danger">
                    {{
                      multilingualService.langMap?.LABEL_REGISTRATION_USER_NAME_VALIDATION_INVALID
                    }}
                  </span>
                }
              </div>
              <div class="form-group mb-2">
                <label for="contactNumber">
                  {{ multilingualService.langMap?.LABEL_REGISTRATION_CONTACT_NUMBER }}
                  <span class="input-required-on-dark-bg text-w-600">*</span>
                </label>
                <input
                  formControlName="contactNumber"
                  type="tel"
                  appNumberOnly
                  class="form-control"
                  maxlength="10"
                  minlength="10"
                />
                @if (
                  contactDetailsForm?.controls?.contactNumber?.errors?.required &&
                  contactDetailsForm?.controls?.contactNumber?.touched
                ) {
                  <span role="alert" class="text-danger">
                    {{
                      multilingualService.langMap
                        ?.LABEL_REGISTRATION_CONTACT_NUMBER_VALIDATION_REQUIRED
                    }}
                  </span>
                }
                @if (
                  (contactDetailsForm?.controls?.contactNumber?.errors?.minlength ||
                    contactDetailsForm?.controls?.contactNumber?.errors?.maxlength ||
                    contactDetailsForm?.controls?.contactNumber?.errors?.pattern) &&
                  contactDetailsForm?.controls?.contactNumber?.touched
                ) {
                  <span role="alert" class="text-danger">
                    {{
                      multilingualService.langMap
                        ?.LABEL_REGISTRATION_CONTACT_NUMBER_VALIDATION_INVALID
                    }}
                  </span>
                }
              </div>
              <div class="form-group mb-2">
                <label for="email">
                  {{ multilingualService.langMap?.LABEL_REGISTRATION_EMAIL }}
                  <span class="input-required-on-dark-bg text-w-600">*</span>
                </label>
                <input formControlName="email" type="email" class="form-control" />
                @if (
                  contactDetailsForm?.controls?.email?.errors?.required &&
                  contactDetailsForm?.controls?.email?.touched
                ) {
                  <span role="alert" class="text-danger">
                    {{ multilingualService.langMap?.LABEL_REGISTRATION_EMAIL_VALIDATION_REQUIRED }}
                  </span>
                }
                @if (
                  contactDetailsForm?.controls?.email?.errors?.pattern &&
                  contactDetailsForm?.controls?.email?.touched
                ) {
                  <span role="alert" class="text-danger">
                    {{ multilingualService.langMap?.LABEL_REGISTRATION_EMAIL_VALIDATION_INVALID }}
                  </span>
                }
                <p class="email-note">
                  {{ multilingualService.langMap?.LABEL_REGISTRATION_EMAIL_NOTE }}
                </p>
              </div>
            </form>
            <div class="action-buttons">
              <button
                id="back_btn2"
                aria-label="Go back to prev step"
                class="back-button"
                (click)="handleBackNavigation()"
              >
                {{ multilingualService.langMap?.LABEL_REGISTRATION_BACK_BTN }}
              </button>
              <button
                id="next_btn2"
                aria-label="Go to next step"
                class="primary-button"
                [disabled]="contactDetailsForm.invalid"
                (click)="callPreRegisterAPI()"
              >
                {{ multilingualService.langMap?.LABEL_REGISTRATION_NEXT_BTN }}
              </button>
            </div>
          </mat-step>
        </mat-horizontal-stepper>
        <!-- Action buttons -->
        <div class="footer-section d-flex justify-content-between">
          <div class="help-number">
            <span>
              {{ multilingualService.langMap?.LABEL_COMMON_TECHNICAL_SUPPORT }}
            </span>
            @if (technicalSupportNumber$ | async; as technicalSupportNumber) {
              <a href="tel:{{ technicalSupportNumber }}">{{ technicalSupportNumber }}</a>
            }
          </div>
          <div class="d-flex flex-sm-row justify-content-around signup-action-btns">
            <div class="footer-btn">
              <button id="login_btn" class="secondary-button mr-2" (click)="goToLogin()">
                {{ multilingualService.langMap?.LABEL_REGISTRATION_LOGIN_BTN }}
              </button>
            </div>
            <div class="footer-btn" id="guest_btn_div">
              <button id="guest_btn" class="secondary-button" (click)="goToGuestScreen()">
                {{ multilingualService.langMap?.LABEL_REGISTRATION_CONTINUE_AS_GUEST_BTN }}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
} @else {
  <div class="padding-box center loader-circle">
    <img imageName="loader.gif" [common]="true" alt="loader" width="80px" />
  </div>
}
